<mat-card>
  <div class="kanban-skeleton" *ngIf="!initialLoadDone()" aria-hidden="true">
    <div class="kanban-skeleton-col" *ngFor="let column of [0, 1, 2, 3]">
      <div class="sk sk-header"></div>
      <div class="sk sk-card"></div>
      <div class="sk sk-card"></div>
    </div>
  </div>

  <div class="kanban-empty-state" *ngIf="initialLoadDone() && !hasViews()">
    <mat-icon class="material-icons-outlined">view_kanban</mat-icon>
    <span>{{ 'page.items.kanban.noViews' | translate }}</span>
  </div>

  <app-kanban-view *ngIf="initialLoadDone() && hasViews() && selectedViewId" [items]="items()" [columns]="columnDefs()">
    <mat-dropdown
      kanbanToolbar
      class="kanban-view-select"
      [options]="viewOptions()"
      [configurationInput]="{
        singleSelection: true,
        hasMatError: false,
        text: 'page.items.kanban.viewSelector' | translate,
        repositionDropdownList: true,
      }"
      [formControl]="viewControl"
    ></mat-dropdown>
    <app-items-view-controls itemsViewControls></app-items-view-controls>
  </app-kanban-view>
</mat-card>
